export default import.meta.ROLLDOWN_FILE_URL_qMeSiWBGwzNgVqbXM54vzQ